// Gear module i18n - English
export const gearEn = {
  gear: {
    page: {
      title: 'Gear containers',
      subtitle: 'Organize and manage your gear collections',
      containers: 'Containers',
      items: 'Items',
      viewContainers: 'View Containers',
      readyContainers: 'Ready Containers',
      emptyDescription: 'Get started by creating your first gear container.',
    },
    container: {
      title: 'Container',
      name: 'Name',
      description: 'Description',
      type: 'Type',
      create: {
        title: 'Create Container',
        new: 'Create New',
        description: 'Create a new container to store your gear.',
      },
      edit: {
        title: 'Edit Container',
        description: 'Edit the details of this container.',
      },
      delete: 'Delete Container',
      deleteConfirm: 'Are you sure you want to delete this container?',
      deleteAll: 'Delete All Containers',
      deleteAllConfirm: 'Are you sure you want to delete ALL containers? This action cannot be undone!',
      deleteAllSuccess: 'All containers have been deleted',
      clone: 'Duplicate Container',
      copy: 'Copy',
      cloneDescription: 'Create a copy of this container with all its items.',
      cloneButton: 'Duplicate',
      cloneSuccess: 'Container duplicated successfully',
      cloneOptions: 'Options',
      includeNestedContainers: 'Include nested containers',
      includeNestedContainersDescription: 'Also clone containers that are nested inside this container',
      includePrices: 'Include prices',
      includePricesDescription: 'Copy prices for containers and items',
      totalWeight: 'Total Weight',
      readiness: 'Readiness',
      itemsCount: '{count} items | {count} item | {count} items',
      itemsCountLabel: 'Items',
      editName: 'Edit container name',
      itemImages: {
        title: 'Item Images',
      },
      showItemImages: 'Show Item Images',
      showItemImagesDescription: 'Display item images in container view (only items with primary image)',
      color: 'Color',
      colorSearchPlaceholder: 'Search colors...',
      colorSearchNoResults: 'No colors found',
      showColorLabels: 'Show color names',
      showColorLabelsDescription: 'Display color names below color dots',
      empty: 'No containers yet',
      emptyDescription: 'Create your first container to start organizing your gear.',
      showOnlyRootContainers: 'Show only root containers',
      hideWhenNested: 'Hide on list when nested',
      hideWhenNestedDescription: 'Hide this container from the main list when it is nested inside another container',
      isPublic: 'Public',
      isPublicDescription: 'Make this container visible to other users. Public containers can be viewed by anyone.',
      isPublicStatus: 'Public container - visible to everyone',
      favorite: 'Favorite',
      addFavorite: 'Add to favorites',
      removeFavorite: 'Remove from favorites',
      favoriteAdded: 'Container added to favorites',
      favoriteRemoved: 'Container removed from favorites',
      // Rating fields
      ratings: 'Ratings',
      ownerRating: 'Your Rating (as owner)',
      ownerRatingDescription: 'Rate your container from 1 to 5 stars',
      yourRating: 'Your Rating',
      averageUserRating: 'Average User Rating',
      ratingsCount: 'ratings',
      rateContainer: 'Rate Container',
      deleteRating: 'Delete Rating',
      ratingUpdated: 'Rating updated successfully',
      ratingDeleted: 'Rating deleted successfully',
      updatingRating: 'Updating rating...',
      updated: 'Updated',
      nested: 'Nested',
      parentContainer: 'Parent',
      addNested: 'Add Container',
      addNestedDescription: 'Select a container to nest inside this container.',
      selectContainer: 'Container',
      selectContainerPlaceholder: 'Select a container',
      searchContainers: 'Search containers...',
      noContainersAvailable: 'No containers available to nest.',
      recentContainers: 'Recent',
      allContainers: 'All containers',
      // Extended fields
      extendedFields: 'Additional Information',
      brand: 'Brand',
      price: 'Price',
      currency: 'Currency',
      weight: 'Weight',
      weightUnit: 'Weight Unit',
      maxWeight: 'Max Weight',
      maxWeightUnit: 'Max Weight Unit',
      weightLimit: 'Weight Limit',
      weightLimitExceeded: 'Weight limit exceeded',
      weightLimitWarning: 'Close to weight limit',
      url: 'URL',
      colors: {
        default: 'Default',
        coyote: 'Coyote',
        khaki: 'Khaki',
        olive: 'Olive',
        forestGreen: 'Forest Green',
        tan: 'Tan',
        brown: 'Brown',
        black: 'Black',
        navy: 'Navy',
        jeans: 'Jeans',
        gray: 'Gray',
        orange: 'Orange',
      },
      types: {
        backpack: 'Backpack',
        bag: 'Bag',
        pouch: 'Pouch',
        box: 'Box',
        cabinet: 'Cabinet',
        vehicle: 'Vehicle',
        shelf: 'Shelf',
        drawer: 'Drawer',
        case: 'Case',
        trunk: 'Trunk',
        ubranie: 'Clothing',
        naczynie: 'Vessel',
        other: 'Other',
        // Legacy types (for backward compatibility)
        bugOutBag: 'Bug-Out Bag',
        edc: 'EDC',
        getHomeBag: 'Get Home Bag',
        custom: 'Custom',
      },
      hiddenByReports: {
        title: 'Container Hidden from Public View',
        description: 'This container has been hidden from public views due to content reports. An administrator can restore it after review.',
      },
    },
    item: {
      title: 'Item',
      name: 'Name',
      image: 'Image',
      category: 'Category',
      quantity: 'Quantity',
      weight: 'Weight',
      weightUnit: 'Unit',
      weightUnits: {
        g: 'g',
        kg: 'kg',
        oz: 'oz',
        lb: 'lb',
      },
      units: {
        piece: 'pcs',
      },
      notes: 'Notes',
      expirationDate: 'Expiration Date',
      shelfLife: 'Shelf Life',
      shelfLifePlaceholder: 'e.g. 10',
      shelfLifeUnitPlaceholder: 'Unit',
      shelfLifeUnit: {
        days: 'Days',
        months: 'Months',
        years: 'Years',
      },
      shelfLifeDescription: 'Set the shelf life period (e.g., 10 years) before purchasing the item. You can later set the expiration date based on this period.',
      priority: 'Priority',
      status: 'Status',
      create: 'Add Item',
      edit: 'Edit Item',
      delete: 'Delete Item',
      deleteConfirm: 'Are you sure you want to delete this item?',
      totalWeight: 'Total Weight',
      totalPrice: 'Total Price',
      empty: 'No items yet',
      emptyDescription: 'Add your first item to this container.',
      container: 'Container',
      containerPlaceholder: 'Select a container (optional)',
      noContainer: 'No container (regular item)',
      containerHelp: 'Select a container to nest it inside this container as an item.',
      moveItem: 'Move Item',
      moveItemDescription: 'Move this item to a different container.',
      noOtherContainers: 'No other containers available.',
      nestedContainer: 'Container',
      viewContainer: 'View Container',
      expandContainer: 'Expand container',
      collapseContainer: 'Collapse container',
      containerContents: 'Container Contents',
      emptyContainer: 'This container is empty',
      categories: {
        water: 'Water',
        food: 'Food',
        shelter: 'Shelter',
        fire: 'Fire',
        firstAid: 'First Aid',
        blades: 'Blades',
        tool: 'Tools', // Alias for "tools" (singular form)
        tools: 'Tools',
        light: 'Light',
        navigation: 'Navigation',
        communication: 'Communication',
        clothing: 'Clothing',
        hygiene: 'Hygiene',
        container: 'Container',
        other: 'Other',
      },
      priorities: {
        critical: 'Critical',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
      },
      statuses: {
        owned: 'Owned',
        missing: 'Missing',
        toBuy: 'To Buy',
      },
      catalog: {
        tabNew: 'New Item',
        tabExisting: 'From Catalog',
        selectItem: 'Select an item...',
        searchItems: 'Search items...',
        noItemsFound: 'No items found.',
      },
      expiration: {
        expired: 'Expired',
        expiringSoon: 'Expiring Soon',
        daysLeft: '{days} days left',
      },
      // Extended fields
      extendedFields: 'Additional Information',
      price: 'Price',
      currency: 'Currency',
      url: 'URL / Link',
      brand: 'Brand',
      color: 'Color',
      quality: 'Quality / Price Tier',
      wearable: 'Wearable',
      wearableDescription: 'Item is worn/carried on person (e.g., clothing, watch, shoes)',
      consumable: 'Consumable',
      consumableDescription: 'Item is consumed/used up (e.g., food, medicine, fuel)',
      showOnContainer: 'Show on Container',
      showOnContainerDescription: 'Display item image in container view gallery',
      hideFromContainer: 'Hide from container view',
      showOnContainerDisabled: 'Image hidden from container view',
      actions: 'Actions',
      details: 'Details',
      openLink: 'Open Link',
      noDetails: 'No additional details available for this item.',
      order: 'Order',
      reorderSuccess: 'Item order has been updated',
      qualities: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
      },
    },
    items: {
      table: {
        title: 'Items table',
      },
    },
    itemsTable: {
      title: 'Items table',
      quickAddPlaceholder: 'Add item…',
      imageCell: {
        uploadSuccess: 'Image uploaded successfully',
        deleteSuccess: 'Image deleted successfully',
        confirmDelete: 'Are you sure you want to delete this image?',
        deleteImage: 'Delete image',
        uploadFromFile: 'Upload from file',
        uploadFromUrl: 'Upload from URL',
        addImageFromUrl: 'Add image from URL',
        addImageFromUrlDescription: 'Enter an image URL to download and add it to this item.',
      },
    },
    actions: {
      show: 'Show',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      reset: 'Reset',
      undo: 'Undo changes',
      moveUp: 'Move up',
      moveDown: 'Move down',
      rateStar: 'Rate {count} star | Rate {count} stars | Rate {count} stars',
      export: 'Export Data',
      exportToJSON: 'Export to JSON',
      import: 'Import Data',
      move: 'Move Item',
      moved: 'Item moved successfully',
      recognizeParameters: 'Recognize Parameters',
      recognizeParametersAll: 'Recognize Parameters for items',
      recognizing: 'Recognizing...',
      parametersRecognized: 'Parameters recognized',
      noParametersFound: 'No parameters found',
      exportToPrompt: 'Export to prompt in Markdown (for AI)',
      exportToPromptSuccess: 'Markdown copied to clipboard',
      exportToPromptDescription: 'Copy the content below and paste it into ChatGPT or another AI',
      exportToCSV: 'Export to CSV',
      aiAssistant: 'AI Assistant',
      aiAssistantPremium: 'AI Assistant (Premium) - Upgrade to unlock',
      moreActions: 'More actions',
      manageShareTokens: 'Manage Share Tokens',
      publishContainer: 'Publish',
      unpublishContainer: 'Unpublish',
      copyPublicLink: 'Copy public link',
      copyPublicLinkSuccess: 'Public link copied to clipboard',
      publicBadgeActions: 'Public container actions',
      enableInlineEditing: 'Enable Inline Editing',
      disableInlineEditing: 'Disable Inline Editing',
      uploadPhoto: 'Upload Photo',
      starItem: 'Star Item',
      manage: 'Manage',
      saving: 'Saving...',
      saved: 'Saved',
      pendingSave: 'Unsaved changes',
      saveError: 'Failed to save changes',
      retrySave: 'Retry save',
      setExpirationDate: 'Set Expiration Date',
    },
    imageSearch: {
      searchImages: 'Search Images',
      searching: 'Searching...',
      noResults: 'No images found',
      imageAdded: 'Image added successfully',
      error: 'Failed to search images',
    },
    fileUpload: {
      imageGallery: {
        title: 'Images',
        noImages: 'No images uploaded yet',
        primary: 'Primary',
        addFromUrl: 'Add from URL',
        urlPlaceholder: 'Paste image URL (https://...)',
        hostOption: 'Host',
        hostLocally: 'Locally (download and store)',
        hostExternally: 'Externally (save URL only)',
        confirmDelete: 'Are you sure you want to delete this image?',
        messages: {
          uploadSuccess: 'Image uploaded successfully',
          uploadSuccessMultiple: '{count} images uploaded successfully',
          uploadFailed: 'Failed to upload image',
          deleteSuccess: 'Image deleted successfully',
          primarySuccess: 'Primary image updated',
          primaryUnset: 'Primary image unset',
          reorderSuccess: 'Images reordered successfully',
          urlRequired: 'Image URL is required',
          urlInvalid: 'Please provide a valid URL',
          fetchingImages: 'Fetching images...',
        },
        tooltips: {
          togglePrimary: 'Toggle primary image',
          dragToReorder: 'Drag to reorder',
          deleteImage: 'Delete image',
        },
        previousImage: 'Previous image',
        nextImage: 'Next image',
      },
    },
    sorting: {
      unsavedChanges: 'Unsaved sorting changes',
      unsavedChangesDescription: 'You have reordered {count} item(s). Save changes to update the order in the database?',
    },
    export: {
      title: 'Lista sprzętu',
      description: 'Lista mojego sprzętu w różnych kontenerach, wygenerowana przez Gear Stack',
      emptyContainer: '*Brak przedmiotów w kontenerze.*',
      allToMarkdown: 'Export to Markdown (for AI)',
      allToCSV: 'Export all to CSV',
      allToJson: 'Export all to JSON',
      jsonSuccess: 'Exported {count} container(s) to JSON',
      noContainers: 'No containers to export',
      guidelines: 'Guidelines',
      guidelinesDescription: 'Formatting guidelines for AI when generating or updating gear lists',
      guidelinesCopied: 'Formatting guidelines copied to clipboard',
      legendTitle: '## Legenda dla AI',
      legendIntro: 'To jest system zarządzania sprzętem/ekwipunkiem. Oto co oznaczają dane:',
      legendContainer: '- **Kontener**: Plecak, torba, saszetka lub inna jednostka przechowywania przedmiotów',
      legendItems: '- **Przedmioty**: Pojedyncze elementy wyposażenia przechowywane w kontenerze',
      legendWeight: '- **Waga**: Całkowita waga uwzględniająca ilość',
      legendBrand: '- **Marka**: Producent/marka przedmiotu',
      legendColor: '- **Kolor**: Kolor przedmiotu',
      legendNested: '- **Zagnieżdżone kontenery**: Kontener może zawierać inny kontener jako przedmiot. Zagnieżdżone kontenery są wyświetlane jako pozycja w liście oraz osobno z pełną zawartością poniżej.',
      legendStatusOwned: 'Przedmiot jest posiadany i dostępny',
      legendStatusMissing: 'Przedmiot jest brakujący lub niedostępny',
      legendStatusToBuy: 'Przedmiot należy zakupić',
      showUuid: 'Show UUID in export',
      showWeight: 'Show weight',
      showColor: 'Show color',
      showBrand: 'Show brand',
      showNestedContainer: 'Show nested container reference',
      showLegend: 'Show legend',
      showPrices: 'Show prices',
      showPricesDescription: 'Include item and container prices in export',
      showNotes: 'Show notes/descriptions',
      toBuyTitle: 'To Buy',
      toBuyTotalCost: 'Total Cost',
      toBuyItemsToPurchase: 'Items to purchase',
      options: 'Export Options',
      descriptionFormat: 'Item descriptions format',
      descriptionFormatOff: 'OFF',
      descriptionFormatInline: 'Inline',
      descriptionFormatNewline: 'New Line',
      csv: {
        title: 'Export to CSV',
        description: 'Configure CSV export options',
        columns: 'Columns to Export',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        separator: 'Separator',
        separatorComma: 'Comma (,)',
        separatorSemicolon: 'Semicolon (;)',
        useBOM: 'UTF-8 with BOM (for Excel compatibility)',
        includeNested: 'Include nested containers',
        itemsCount: 'Will export {count} items',
        success: 'CSV exported successfully',
        noColumnsSelected: 'Please select at least one column',
        export: 'Export',
        categoryBasic: 'Basic',
        categoryPhysical: 'Physical',
        categoryFinancial: 'Financial',
        categoryDetails: 'Details',
        categoryAdditional: 'Additional',
        columnName: 'Name',
        columnCategory: 'Category',
        columnQuantity: 'Quantity',
        columnWeight: 'Weight',
        columnWeightUnit: 'Weight Unit',
        columnPrice: 'Price',
        columnCurrency: 'Currency',
        columnBrand: 'Brand',
        columnColor: 'Color',
        columnStatus: 'Status',
        columnPriority: 'Priority',
        columnUrl: 'URL',
        columnNotes: 'Notes',
        columnContainerName: 'Container Name',
        columnContainerType: 'Container Type',
      },
    },
    allItems: {
      title: 'All Items',
      subtitle: 'View and manage all items from all containers',
      navTitle: 'All Items',
      container: 'Container',
      empty: 'No items found',
      emptyDescription: 'Create containers and add items to see them here.',
      filter: {
        all: 'All',
        containers: 'Containers',
        items: 'Items',
      },
      filters: {
        menu: 'More filters',
        withImage: 'Only with image',
        withoutImage: 'Only without image',
        removeFilter: 'Remove filter',
      },
    },
    sidebar: {
      containerDisambiguator: '{type} · {count} items',
      searchContainers: 'Search containers…',
      favorites: 'Favorites',
      noContainersFound: 'No containers found',
    },
    shopping: {
      title: 'Shopping Planning',
      subtitle: 'Plan your purchases for items to buy and expiring soon',
      navTitle: 'Shopping',
      filters: 'Filters',
      expandFilters: 'Expand filters',
      collapseFilters: 'Collapse filters',
      filterByCategory: 'Filter by Category',
      filterByBudget: 'Filter by Budget',
      budgetPlaceholder: 'Enter budget amount',
      currency: 'PLN',
      clearBudget: 'Clear',
      includeExpiringSoon: 'Include items expiring soon',
      shoppingList: 'Shopping List',
      itemsCount: '{count} items',
      totalQuantity: '{count} pieces',
      clearList: 'Clear List',
      noItems: 'No items found',
      noItemsDescription: 'Try adjusting your filters',
      addedToCart: 'Added to shopping list',
      removedFromCart: 'Removed from shopping list',
      addAll: 'Add All',
      addedAllToCart: 'Added {count} items to shopping list',
      allItemsAlreadyInList: 'All items are already in the shopping list',
      exportMarkdown: 'Export Markdown',
      exportDescription: 'Copy the markdown content below',
      copyMarkdown: 'Copy to Clipboard',
      markdownCopied: 'Markdown copied to clipboard',
      copyFailed: 'Failed to copy markdown',
      generatedAt: 'Generated at',
      totalPrice: 'Total',
      emptyList: 'Shopping list is empty',
      addItem: 'Add',
      addItemDescription: 'Add a new item to your shopping list',
      purchased: 'Purchased',
      markedAsPurchased: 'Item marked as purchased',
      deletedFromList: 'Item removed from shopping list',
      restore: 'Restore',
      restoredToList: 'Item restored to shopping list',
      reset: 'Reset',
      listReset: 'Shopping list reset',
      summary: 'Summary',
      availableItems: 'Available Items',
      deletedItems: 'Deleted Items',
      noContainer: 'No container available',
      itemAdded: 'Item added',
      incrementQuantity: 'Increase quantity',
      decrementQuantity: 'Decrease quantity',
      removeFromList: 'Remove from list',
    },
    chart: {
      title: 'Category Distribution',
      description: 'Visualization of item categories in container',
      byWeight: 'Weight',
      byQuantity: 'Quantity',
      byPrice: 'Price',
      byPriority: 'Priority',
      byWeightBreakdown: 'Other / Worn / Consumable',
      legend: 'Legend',
      total: 'Total',
      noData: 'No data to display',
      loading: 'Loading chart...',
    },
    weightBreakdown: {
      base: 'Other',
      worn: 'Worn',
      consumable: 'Consumable',
      baseDescription: 'Items carried in pack (not worn or consumable)',
      wornDescription: 'Items worn on person',
      consumableDescription: 'Items that are consumed/used up',
    },
    filters: {
      search: 'Search items...',
      searchContainers: 'Search containers...',
      category: 'Category',
      categoryQuickFilters: 'Category filters',
      filterByCategory: 'Filter by {category}',
      status: 'Status',
      priority: 'Priority',
      all: 'All',
      refresh: 'Refresh containers',
    },
    validation: {
      nameRequired: 'Name is required',
      quantityMin: 'Quantity must be greater than 0',
      weightMin: 'Weight cannot be negative',
    },
    comboBox: {
      add: 'Add',
    },
    import: {
      title: 'Import from Markdown',
      description: 'Paste markdown content to import containers and items.',
      fromMarkdown: 'Import from Markdown',
      markdownContent: 'Markdown Content',
      placeholder: `## Container Name
- Item name **Brand** (params) x5
- Another item **Brand** ~25 m (color)`,
      preview: 'Preview',
      import: 'Import',
      previewTitle: 'Preview Import',
      emptyContent: 'Please paste markdown content first',
      noContainersFound: 'No containers found in the markdown',
      noPreview: 'Please preview the import first',
      previewSuccess: '{count} container(s) found',
      success: 'Successfully imported {containers} container(s) with {items} item(s)',
      successWithUpdates: 'Created {created} containers, updated {updated} containers, created {items} items, updated {itemsUpdated} items',
      importedDescription: 'Imported from markdown',
      errors: 'Parsing Errors',
      items: 'items',
      andMore: '+ {count} more...',
      mode: 'Import Mode',
      modeUpdate: 'Update Existing (by UUID)',
      modeUpdateDesc: 'Update existing containers/items if UUID matches, create new if not found',
      modeCreate: 'Create New',
      modeCreateDesc: 'Always create new containers/items, ignore UUIDs',
      recognizeFromName: 'Recognize brand and color from name',
      recognizeFromNameDesc: 'Automatically detect brand and color from item names (same as when creating items manually)',
      parsing: 'Parsing markdown...',
      parseProgress: 'Parse progress',
      importing: 'Importing...',
      progress: 'Progress',
      importingItem: 'Importing item',
    },
    sampleSet: {
      generate: 'Generate Sample Set',
      generateButton: 'Generate Sample Set',
      success: 'Sample set generated successfully',
      backpack: 'Backpack',
      pouch: 'Fire Kit Pouch',
      knife: 'Knife [name]',
      multiTool: 'Multi-tool [name]',
      flashlight: 'Flashlight [name]',
      firstAidKit: 'First Aid Kit',
      paracord: 'Paracord',
      ferroRod: 'Ferro Rod / Fire Starter',
      tinder: 'Tinder / Char Cloth',
      lighter: 'Lighter',
      variants: {
        firePouch: {
          name: 'Fire Pouch',
          description: 'Minimalist fire starting kit',
        },
        bugOutBag: {
          name: 'Bug Out Bag',
          description: 'Complete survival kit for emergency situations',
          firePouch: 'Fire Pouch',
        },
        edc: {
          name: 'EDC (Every Day Carry)',
          description: 'Essential items for daily carry',
        },
        budgetEdc: {
          name: 'Budget EDC Survival Kit',
          description: 'Affordable everyday carry survival essentials',
        },
        mediumEdc: {
          name: 'Medium EDC / Urban Survival Kit',
          description: 'Mid-range everyday carry with urban survival focus',
        },
      },
      items: {
        lightMyFireFiresteel: {
          name: 'Light My Fire FireSteel 2.0',
          notes: 'Ferrocerium rod with striker',
        },
        coghlansTinderQuik: {
          name: 'Coghlan\'s Tinder Quik',
          notes: 'Tinder tabs',
        },
        bicLighter: {
          name: 'BIC Lighter',
          notes: 'Classic disposable lighter',
        },
        ucoStormproofMatches: {
          name: 'UCO Stormproof Matches',
          notes: 'Waterproof matches in case',
        },
        moraknivCompanion: {
          name: 'Morakniv Companion',
          notes: 'Fixed blade knife',
        },
        leathermanWave: {
          name: 'Leatherman Wave+',
          notes: 'Multi-tool with pliers',
        },
        fenixPD36R: {
          name: 'Fenix PD36R',
          notes: 'Rechargeable flashlight',
        },
        adventureMedicalKitsUltralight: {
          name: 'Adventure Medical Kits Ultralight',
          notes: 'First aid kit',
        },
        paracord550: {
          name: 'Paracord 550',
          notes: '50ft paracord',
        },
        lifestrawPersonal: {
          name: 'LifeStraw Personal Water Filter',
          notes: 'Portable water filter',
        },
        solEmergencyBivvy: {
          name: 'SOL Emergency Bivvy',
          notes: 'Emergency shelter',
        },
        victorinoxClassicSD: {
          name: 'Victorinox Swiss Army Knife Classic SD',
          notes: 'Compact multi-tool',
        },
        olightI3TEOS: {
          name: 'Olight I3T EOS',
          notes: 'Keychain flashlight',
        },
        zippoLighter: {
          name: 'Zippo Lighter',
          notes: 'Windproof lighter',
        },
        fieldNotesNotebook: {
          name: 'Field Notes Notebook',
          notes: 'Pocket notebook',
        },
        fisherSpacePen: {
          name: 'Fisher Space Pen',
          notes: 'Pressurized pen',
        },
        ankerPowerCore10000: {
          name: 'Anker PowerCore 10000',
          notes: 'Portable power bank',
        },
        riteInTheRainNotepad: {
          name: 'Rite in the Rain All-Weather Notepad 3x5',
          notes: 'Waterproof notepad',
        },
        sharpieMarker: {
          name: 'Sharpie Permanent Marker',
          notes: 'Fine tip permanent marker',
        },
        ductTape: {
          name: 'Compact Duct Tape (10 m)',
          notes: 'Repair and improvisation tape',
        },
        metalSpork: {
          name: 'Metal Spork',
          notes: 'Folding titanium / stainless spork',
        },
        cnocVectoBottle: {
          name: 'CNOC Vecto Collapsible Water Bottle 1L',
          notes: 'Collapsible water bottle',
        },
        fenixE01: {
          name: 'Fenix E01 V2.0',
          notes: 'Ultra-light AAA backup flashlight',
        },
        victorinoxHuntsman: {
          name: 'Victorinox Huntsman',
          notes: 'Swiss Army knife with saw and scissors',
        },
        ferroRod8mm: {
          name: 'Ferrocerium Rod 8 mm',
          notes: 'Compact ferro rod fire starter',
        },
        gsiStainlessCup: {
          name: 'GSI Outdoors Stainless Steel Cup 700 ml',
          notes: 'Metal cup for boiling water or meals',
        },
        milTecEmergencyBlanket: {
          name: 'Mil-Tec Emergency Thermal Blanket',
          notes: 'Emergency foil blanket',
        },
        basicMiniFirstAidKit: {
          name: 'Adventure Medical Kits Ultralight/.5',
          notes: 'Compact first aid kit for 1–2 people',
        },
      },
    },
    migration: {
      title: 'Migrate Local Data?',
      description: 'We found data stored locally. Would you like to migrate it to your account?',
      benefits: {
        title: 'Benefits of migration:',
        sync: 'Sync across all your devices',
        backup: 'Automatic cloud backup',
        access: 'Access from anywhere',
      },
      note: 'Your local data will remain available even after migration. You can continue using the app offline.',
      skip: 'Skip',
      migrate: 'Migrate',
      migrating: 'Migrating...',
      success: 'Data migrated successfully!',
      error: 'Failed to migrate data. Please try again.',
    },
    publicContainers: {
      title: 'Public Containers',
      navTitle: 'Public containers',
      description: 'Browse containers shared by other users',
      by: 'by',
      author: 'Author',
      empty: 'No public containers',
      emptyDescription: 'There are no public containers available yet. Create a container and mark it as public to share it with others.',
    },
    sharedContainers: {
      title: 'Shared Container',
      notFound: 'Shared container not found or token expired',
      invalidToken: 'Invalid or expired share token',
    },
    shareTokens: {
      title: 'Manage Share Tokens',
      create: 'Create Token',
      createFirst: 'Create First Token',
      createDescription: 'Create a new share token to allow others to view this container via a link.',
      shareUrl: 'Share URL',
      created: 'Created',
      expires: 'Expires',
      noExpiry: 'Never',
      expiryDate: 'Expiry Date (Optional)',
      expiryPlaceholder: 'Leave empty for no expiry',
      expiryHint: 'Leave empty to create a token that never expires.',
      empty: 'No share tokens created yet.',
      copied: 'Share URL copied to clipboard',
      createdSuccess: 'Share token created successfully',
      revoked: 'Share token revoked successfully',
      confirmRevoke: 'Are you sure you want to revoke this share token?',
      errorLoading: 'Failed to load share tokens',
      errorCreating: 'Failed to create share token',
      errorRevoking: 'Failed to revoke share token',
      errorCopying: 'Failed to copy to clipboard',
    },
    errors: {
      ratingFailed: 'Failed to rate container',
      deleteRatingFailed: 'Failed to delete rating',
    },
    report: {
      title: 'Report Inappropriate Content',
      description: 'Help us keep the community safe by reporting containers that violate our guidelines.',
      reason: 'Reason',
      reasonPlaceholder: 'Select a reason',
      reasonRequired: 'Please select a reason',
      reasons: {
        spam_fraud: 'Spam / Fraud',
        violence: 'Violence',
        sexual_content: 'Sexual Content',
        profanity: 'Profanity',
        other: 'Other',
      },
      additionalInfo: 'Additional Information',
      additionalInfoPlaceholder: 'Provide any additional details (optional)',
      additionalInfoHint: 'Optional: Add any additional context that might help us review this report.',
      submit: 'Report',
      cancel: 'Cancel',
      success: 'Report Submitted',
      successDescription: 'Thank you for your report. We will review it shortly.',
      error: 'Failed to submit report. Please try again.',
      alreadyReported: 'You have already reported this container',
      alreadyReportedInfo: 'You have already reported this container',
      withdraw: 'Withdraw Report',
      withdrawConfirm: 'Are you sure you want to withdraw your report?',
      withdrawSuccess: 'Report withdrawn successfully',
      withdrawError: 'Failed to withdraw report',
      clickToWithdraw: 'Click to withdraw your report',
      report: 'Report',
    },
    pages: {
      allItems: 'All Items',
      shoppingPlanning: 'Shopping Planning',
      containerDetail: 'Container Details',
      itemDetail: 'Item Details',
      publicContainers: 'Public Containers',
      publicContainerDetail: 'Public Container',
      publicItemDetail: 'Public Item',
      sharedContainerDetail: 'Shared Container',
    },
    settings: {
      page: {
        title: 'Gear Settings',
        subtitle: 'Manage your gear-specific preferences and settings',
      },
      ai: {
        title: 'AI Settings',
        description: 'Configure AI model, API token, and usage limits',
        defaultModel: {
          label: 'Default Model',
          subtitle: 'Select the default AI model to use for chat and suggestions',
          placeholder: 'Select a model',
        },
        apiToken: {
          label: 'API Token',
          subtitle: 'Use your own OpenRouter API token for unlimited usage (optional)',
          placeholder: 'Enter your OpenRouter API token',
          save: 'Save Token',
          remove: 'Remove Token',
          configured: 'Token configured',
          encrypted: 'Token is encrypted and stored securely',
          confirmRemove: {
            title: 'Remove API Token',
            description: 'Are you sure you want to remove your API token? You will need to configure it again to use AI features with your own token.',
          },
        },
        usage: {
          label: 'Usage & Limits',
          subtitle: 'Current usage statistics and limits for this month',
          tokens: 'Tokens',
          cost: 'Cost',
          unlimited: 'Unlimited',
          noLimit: 'No limit',
          unavailable: 'Unavailable',
          ownTokenNote: 'You are using your own API token. Usage is unlimited.',
          systemTokenNote: 'You are using the system token. Limits apply.',
        },
        modelUpdated: 'Model updated successfully',
        tokenSaved: 'API token saved successfully',
        tokenRemoved: 'API token removed successfully',
        tokenRequired: 'API token is required',
        tokenSaveError: 'Failed to save API token',
        tokenRemoveError: 'Failed to remove API token',
      },
      accountLimits: {
        title: 'Account Limits',
        description: 'Your account limits and current usage',
        plan: 'Plan',
        tier: {
          free: 'Free',
          pro: 'Pro',
          proPlus: 'Pro Plus',
        },
        items: 'Items',
        containers: 'Containers',
        used: 'used',
        upgradePrompt: 'You are approaching your account limits. Consider upgrading to Pro for more storage.',
      },
    },
    catalogue: {
      title: 'Global Catalogue',
      subtitle: 'Browse and add items from the global catalogue',
      navTitle: 'Catalogue',
      browser: 'Catalogue Browser',
      search: 'Search catalogue...',
      searchPlaceholder: 'Search by name, brand, or model...',
      filters: 'Filters',
      category: 'Category',
      brand: 'Brand',
      priceTier: 'Price Tier',
      quality: 'Quality',
      clearFilters: 'Clear Filters',
      noResults: 'No catalogue items found',
      noResultsDescription: 'Try adjusting your search or filters',
      itemDetail: 'Catalogue Item Details',
      addToContainer: 'Add to Container',
      selectContainer: 'Select Container',
      selectContainerPlaceholder: 'Choose a container...',
      addOptions: 'Add Options',
      quantity: 'Quantity',
      status: 'Status',
      priority: 'Priority',
      copyImage: 'Add with image',
      shouldRedirectToContainer: 'Redirect to container after adding',
      addedToContainer: 'Item added to container successfully',
      matchWithCatalogue: 'Match with Catalogue',
      matchedWithCatalogue: 'Item matched with catalogue successfully',
      searchCatalogue: 'Search Catalogue',
      noMatchesFound: 'No matches found',
      selectedCatalogueItem: 'Selected Catalogue Item',
      match: 'Match',
      description: 'Description',
      weightWithUnit: 'Weight (with unit)',
      priceWithCurrency: 'Price (with currency)',
      updateFromCatalogue: 'Update from Catalogue',
      updatedFromCatalogue: 'Item updated from catalogue successfully',
      selectFieldsToUpdate: 'Select which fields to update from the catalogue',
      update: 'Update',
      fetchImagesFromCatalogue: 'Fetch Images from Catalogue',
      fetchedImagesFromCatalogue: 'Images fetched from catalogue successfully',
      unlinkFromCatalogue: 'Unlink from Catalogue',
      unlinkConfirm: 'Are you sure you want to unlink this item from the catalogue?',
      unlinkedSuccess: 'Item unlinked from catalogue',
      linkedToCatalogue: 'Linked to Catalogue',
      viewInCatalogue: 'View in Catalogue',
      fromCatalogue: 'From Catalogue',
      priceTiers: {
        low: 'Budget',
        medium: 'Mid-range',
        high: 'Premium',
      },
      create: {
        title: 'Create Catalogue Item',
        description: 'Add a new item to the global catalogue',
      },
      edit: {
        title: 'Edit Catalogue Item',
        description: 'Update catalogue item details',
      },
      version: 'Version',
      createdBy: 'Created by',
      user: 'User',
      isActive: 'Active',
      makeInactive: 'Deactivate',
      makeActive: 'Activate',
      delete: 'Delete Catalogue Item',
      deleteConfirm: 'Are you sure you want to delete this catalogue item?',
      empty: 'No catalogue items',
      emptyDescription: 'The global catalogue is empty. Add items to help others find gear.',
      metadata: 'Metadata',
      metadataCreated: 'Created',
      metadataUpdated: 'Updated',
      model: 'Model',
      admin: 'Admin',
      shops: 'Shops',
      shopsTitle: 'Where to buy',
      shopLink: 'Shop link',
      openShop: 'Open shop',
      priceDate: 'Approximate price as of {date}',
    },
    promotion: {
      title: 'Promote to Catalogue',
      promotions: 'Promotions',
      promoteButton: 'Promote',
      alreadyPromoted: 'You have already promoted this item',
      addedToCatalogue: 'Item has been added to the catalogue',
      inCatalogue: 'In Catalogue',
      remaining: '0 remaining | 1 remaining | {count} remaining',
      thresholdReached: 'Threshold reached! Item will be added to catalogue.',
      requirements: 'Only registered users with accounts older than 1 month can promote items.',
      success: 'Item promoted successfully',
      addToCatalogueAdmin: 'Add to Catalogue',
    },
    visualization: {
      title: 'Visualization',
      navTitle: 'Visualization',
      description: 'Visual map of your gear by storage zone',
      zones: {
        body: 'On Body',
        carry: 'Carry',
        vehicle: 'Vehicle',
        home: 'Home / Storage',
        other: 'Other',
      },
      zoneEmpty: 'No containers in this zone',
      addZone: 'Add Zone',
      zoneDialog: {
        addTitle: 'Add Zone',
        editTitle: 'Edit Zone',
        nameLabel: 'Name',
        namePlaceholder: 'e.g. Boat, Campsite',
        iconLabel: 'Icon',
      },
      confirmDeleteZone: 'Delete this zone? Containers placed here will move back to their default zone.',
    },
  },
}

// Gear module i18n - Polish
export const gearPl = {
  gear: {
    page: {
      title: 'Kontenery sprzętu',
      subtitle: 'Organizuj i zarządzaj swoimi kolekcjami sprzętu',
      containers: 'Kontenery',
      items: 'Przedmioty',
      viewContainers: 'Zobacz Kontenery',
      readyContainers: 'Gotowe Kontenery',
      emptyDescription: 'Zacznij od utworzenia swojego pierwszego kontenera sprzętu.',
    },
    container: {
      title: 'Kontener',
      name: 'Nazwa',
      description: 'Opis',
      type: 'Typ',
      create: {
        title: 'Utwórz Kontener',
        new: 'Utwórz Nowy',
        description: 'Utwórz nowy kontener do przechowywania swojego sprzętu.',
      },
      edit: {
        title: 'Edytuj Kontener',
        description: 'Edytuj szczegóły tego kontenera.',
      },
      delete: 'Usuń Kontener',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten kontener?',
      deleteAll: 'Usuń wszystkie kontenery',
      deleteAllConfirm: 'Czy na pewno chcesz usunąć WSZYSTKIE kontenery? Tej operacji nie można cofnąć!',
      deleteAllSuccess: 'Wszystkie kontenery zostały usunięte',
      clone: 'Duplikuj Kontener',
      copy: 'Kopia',
      cloneDescription: 'Utwórz kopię tego kontenera wraz z wszystkimi przedmiotami.',
      cloneButton: 'Duplikuj',
      cloneSuccess: 'Kontener został zduplikowany',
      cloneOptions: 'Opcje',
      includeNestedContainers: 'Uwzględnij zagnieżdżone kontenery',
      includeNestedContainersDescription: 'Sklonuj również kontenery, które są zagnieżdżone w tym kontenerze',
      includePrices: 'Uwzględnij ceny',
      includePricesDescription: 'Skopiuj ceny dla kontenerów i przedmiotów',
      totalWeight: 'Waga',
      readiness: 'Gotowość',
      itemsCount: '{count} przedmiotów | {count} przedmiot | {count} przedmioty | {count} przedmiotów',
      itemsCountLabel: 'Przedmiotów',
      editName: 'Edytuj nazwę kontenera',
      itemImages: {
        title: 'Obrazki przedmiotów',
        hidden: 'Obrazki przedmiotów ukryte',
      },
      showItemImages: 'Pokaż obrazki przedmiotów',
      showItemImagesDescription: 'Wyświetl obrazki przedmiotów w widoku kontenera (tylko przedmioty z obrazkiem głównym)',
      hideItemImages: 'Ukryj obrazki przedmiotów',
      color: 'Kolor',
      colorSearchPlaceholder: 'Szukaj kolorów...',
      colorSearchNoResults: 'Nie znaleziono kolorów',
      showColorLabels: 'Pokaż nazwy kolorów',
      showColorLabelsDescription: 'Wyświetlaj nazwy kolorów pod kropkami',
      empty: 'Brak kontenerów',
      emptyDescription: 'Utwórz swój pierwszy kontener, aby zacząć organizować sprzęt.',
      showOnlyRootContainers: 'Pokaż tylko kontenery główne',
      hideWhenNested: 'Ukryj na liście gdy zagnieżdżony',
      hideWhenNestedDescription: 'Ukryj ten kontener z głównej listy, gdy jest zagnieżdżony w innym kontenerze',
      isPublic: 'Publiczny',
      isPublicDescription: 'Udostępnij ten kontener innym użytkownikom. Kontenery publiczne mogą być przeglądane przez każdego.',
      isPublicStatus: 'Kontener publiczny - widoczny dla każdego',
      favorite: 'Ulubiony',
      addFavorite: 'Dodaj do ulubionych',
      removeFavorite: 'Usuń z ulubionych',
      favoriteAdded: 'Kontener dodany do ulubionych',
      favoriteRemoved: 'Kontener usunięty z ulubionych',
      // Rating fields
      ratings: 'Oceny',
      ownerRating: 'Twoja ocena (jako właściciel)',
      ownerRatingDescription: 'Oceń swój kontener od 1 do 5 gwiazdek',
      yourRating: 'Twoja ocena',
      averageUserRating: 'Średnia ocena użytkowników',
      ratingsCount: 'ocen',
      rateContainer: 'Oceń kontener',
      deleteRating: 'Usuń ocenę',
      ratingUpdated: 'Ocena została zaktualizowana',
      ratingDeleted: 'Ocena została usunięta',
      updatingRating: 'Aktualizowanie oceny...',
      updated: 'Zaktualizowano',
      nested: 'Zagnieżdżony',
      parentContainer: 'Rodzic',
      addNested: 'Dodaj Kontener',
      addNestedDescription: 'Wybierz kontener, aby zagnieździć go w tym kontenerze.',
      selectContainer: 'Kontener',
      selectContainerPlaceholder: 'Wybierz kontener',
      searchContainers: 'Szukaj kontenerów...',
      noContainersAvailable: 'Brak dostępnych kontenerów do zagnieżdżenia.',
      recentContainers: 'Ostatnie',
      allContainers: 'Wszystkie kontenery',
      // Extended fields
      extendedFields: 'Dodatkowe Informacje',
      brand: 'Marka',
      price: 'Cena',
      currency: 'Waluta',
      weight: 'Waga',
      weightUnit: 'Jednostka wagi',
      maxWeight: 'Maks. waga',
      maxWeightUnit: 'Jednostka maks. wagi',
      weightLimit: 'Limit wagi',
      weightLimitExceeded: 'Przekroczono limit wagi',
      weightLimitWarning: 'Blisko limitu wagi',
      url: 'URL',
      colors: {
        default: 'Domyślny',
        coyote: 'Coyote',
        khaki: 'Khaki',
        olive: 'Oliwkowy',
        forestGreen: 'Zielony Leśny',
        tan: 'Beżowy',
        brown: 'Brązowy',
        black: 'Czarny',
        navy: 'Granatowy',
        jeans: 'Jeans',
        gray: 'Szary',
        orange: 'Pomarańczowy',
      },
      types: {
        backpack: 'Plecak',
        bag: 'Torba',
        pouch: 'Pouch',
        box: 'Skrzynka',
        cabinet: 'Szafa',
        vehicle: 'Pojazd',
        shelf: 'Półka',
        drawer: 'Szuflada',
        case: 'Walizka',
        trunk: 'Bagażnik',
        ubranie: 'Ubranie',
        naczynie: 'Naczynie',
        other: 'Inne',
        // Legacy types (for backward compatibility)
        bugOutBag: 'Bug-Out Bag',
        edc: 'EDC',
        getHomeBag: 'Get Home Bag',
        custom: 'Niestandardowy',
      },
      hiddenByReports: {
        title: 'Kontener ukryty z widoków publicznych',
        description: 'Ten kontener został ukryty z widoków publicznych z powodu zgłoszeń nieodpowiednich treści. Administrator może go przywrócić po weryfikacji.',
      },
    },
    item: {
      title: 'Przedmiot',
      name: 'Nazwa',
      image: 'Obrazek',
      category: 'Kategoria',
      quantity: 'Ilość',
      weight: 'Waga',
      weightUnit: 'Jednostka',
      weightUnits: {
        g: 'g',
        kg: 'kg',
        oz: 'oz',
        lb: 'lb',
      },
      units: {
        piece: 'szt.',
      },
      notes: 'Notatki',
      expirationDate: 'Data ważności',
      shelfLife: 'Okres przydatności',
      shelfLifePlaceholder: 'np. 10',
      shelfLifeUnitPlaceholder: 'Jednostka',
      shelfLifeUnit: {
        days: 'Dni',
        months: 'Miesiące',
        years: 'Lata',
      },
      shelfLifeDescription: 'Ustaw okres przydatności (np. 10 lat) przed zakupem przedmiotu. Później możesz ustawić datę ważności na podstawie tego okresu.',
      priority: 'Priorytet',
      status: 'Status',
      create: 'Dodaj Przedmiot',
      edit: 'Edytuj Przedmiot',
      delete: 'Usuń Przedmiot',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten przedmiot?',
      totalWeight: 'Waga',
      totalPrice: 'Całkowita Cena',
      empty: 'Brak przedmiotów',
      emptyDescription: 'Dodaj swój pierwszy przedmiot do tego kontenera.',
      container: 'Kontener',
      containerPlaceholder: 'Wybierz kontener (opcjonalnie)',
      noContainer: 'Brak kontenera (zwykły przedmiot)',
      containerHelp: 'Wybierz kontener, aby zagnieździć go w tym kontenerze jako przedmiot.',
      moveItem: 'Przenieś Przedmiot',
      moveItemDescription: 'Przenieś ten przedmiot do innego kontenera.',
      noOtherContainers: 'Brak innych kontenerów.',
      nestedContainer: 'Kontener',
      viewContainer: 'Zobacz Kontener',
      expandContainer: 'Rozwiń kontener',
      collapseContainer: 'Zwiń kontener',
      containerContents: 'Zawartość Kontenera',
      emptyContainer: 'Ten kontener jest pusty',
      categories: {
        water: 'Woda',
        food: 'Jedzenie',
        shelter: 'Schronienie',
        fire: 'Ogień',
        firstAid: 'Pierwsza Pomoc',
        blades: 'Ostrza',
        tool: 'Narzędzia', // Alias for "tools" (singular form)
        tools: 'Narzędzia',
        light: 'Światło',
        navigation: 'Nawigacja',
        communication: 'Komunikacja',
        clothing: 'Odzież',
        hygiene: 'Higiena',
        container: 'Kontener',
        other: 'Inne',
      },
      priorities: {
        critical: 'Krytyczny',
        high: 'Wysoki',
        medium: 'Średni',
        low: 'Niski',
      },
      statuses: {
        owned: 'Posiadane',
        missing: 'Brakuje',
        toBuy: 'Do kupienia',
      },
      catalog: {
        tabNew: 'Nowy Przedmiot',
        tabExisting: 'Z Katalogu',
        selectItem: 'Wybierz przedmiot...',
        searchItems: 'Szukaj przedmiotów...',
        noItemsFound: 'Nie znaleziono przedmiotów.',
      },
      expiration: {
        expired: 'Przeterminowane',
        expiringSoon: 'Wkrótce Wygasa',
        daysLeft: 'Pozostało {days} dni',
      },
      // Extended fields
      extendedFields: 'Dodatkowe Informacje',
      price: 'Cena',
      currency: 'Waluta',
      url: 'URL / Link',
      brand: 'Marka',
      color: 'Kolor',
      quality: 'Jakość / Półka cenowa',
      wearable: 'Noszone',
      wearableDescription: 'Przedmiot noszony na sobie (np. odzież, zegarek, buty)',
      consumable: 'Zużywalne',
      consumableDescription: 'Przedmiot zużywany/zużywalny (np. jedzenie, lekarstwa, paliwo)',
      showOnContainer: 'Pokaż w Kontenerze',
      showOnContainerDescription: 'Wyświetl obrazek przedmiotu w galerii widoku kontenera',
      hideFromContainer: 'Ukryj z widoku kontenera',
      showOnContainerDisabled: 'Obrazek ukryty z widoku kontenera',
      actions: 'Akcje',
      details: 'Szczegóły',
      openLink: 'Otwórz Link',
      noDetails: 'Brak dodatkowych szczegółów dla tego przedmiotu.',
      order: 'Kolejność',
      reorderSuccess: 'Kolejność przedmiotów została zaktualizowana',
      qualities: {
        low: 'Niska',
        medium: 'Średnia',
        high: 'Wysoka',
      },
    },
    items: {
      table: {
        title: 'Tabela przedmiotów',
      },
    },
    itemsTable: {
      title: 'Tabela przedmiotów',
      quickAddPlaceholder: 'Dodaj przedmiot…',
      imageCell: {
        uploadSuccess: 'Obrazek został dodany',
        deleteSuccess: 'Obrazek został usunięty',
        confirmDelete: 'Czy na pewno chcesz usunąć ten obrazek?',
        deleteImage: 'Usuń obrazek',
        uploadFromFile: 'Prześlij z pliku',
        uploadFromUrl: 'Prześlij z URL',
        addImageFromUrl: 'Dodaj obrazek z URL',
        addImageFromUrlDescription: 'Wprowadź adres URL obrazka, aby go pobrać i dodać do tego przedmiotu.',
      },
    },
    actions: {
      show: 'Pokaż',
      add: 'Dodaj',
      edit: 'Edytuj',
      delete: 'Usuń',
      save: 'Zapisz',
      cancel: 'Anuluj',
      reset: 'Resetuj',
      undo: 'Cofnij zmiany',
      moveUp: 'Przenieś w górę',
      moveDown: 'Przenieś w dół',
      rateStar: 'Oceń {count} gwiazdką | Oceń {count} gwiazdkami | Oceń {count} gwiazdek | Oceń {count} gwiazdek',
      export: 'Eksportuj dane',
      exportToJSON: 'Eksport do JSON',
      import: 'Importuj dane',
      move: 'Przenieś Przedmiot',
      moved: 'Przedmiot przeniesiony pomyślnie',
      recognizeParameters: 'Rozpoznaj parametry',
      recognizeParametersAll: 'Rozpoznaj parametry przedmiotów',
      recognizing: 'Rozpoznawanie...',
      parametersRecognized: 'Rozpoznano parametry {count} przedmiotów | Rozpoznano parametry {count} przedmiotu | Rozpoznano parametry {count} przedmiotów | Rozpoznano parametry {count} przedmiotów',
      noParametersFound: 'Nie znaleziono parametrów',
      exportToPrompt: 'Eksport do Markdown (dla AI)',
      exportToPromptSuccess: 'Markdown skopiowany do schowka',
      exportToPromptDescription: 'Skopiuj poniższą treść i wklej do ChatGPT lub innego AI',
      exportToCSV: 'Eksport do CSV',
      aiAssistant: 'Asystent AI',
      aiAssistantPremium: 'Asystent AI (Premium) - Uaktualnij, aby odblokować',
      moreActions: 'Więcej akcji',
      manageShareTokens: 'Zarządzaj Tokenami Udostępniania',
      publishContainer: 'Publikuj',
      unpublishContainer: 'Cofnij publikację',
      copyPublicLink: 'Skopiuj link publiczny',
      copyPublicLinkSuccess: 'Link publiczny skopiowany do schowka',
      publicBadgeActions: 'Akcje kontenera publicznego',
      enableInlineEditing: 'Włącz edycję inline',
      disableInlineEditing: 'Wyłącz edycję inline',
      uploadPhoto: 'Dodaj zdjęcie',
      starItem: 'Oznacz jako ulubiony',
      manage: 'Zarządzaj',
      saving: 'Zapisywanie...',
      saved: 'Zapisano',
      pendingSave: 'Niezapisane zmiany',
      saveError: 'Nie udało się zapisać zmian',
      retrySave: 'Ponów zapis',
      setExpirationDate: 'Ustaw Termin Ważności',
    },
    imageSearch: {
      searchImages: 'Wyszukaj obrazki',
      searching: 'Wyszukiwanie...',
      noResults: 'Nie znaleziono obrazków',
      imageAdded: 'Obrazek został dodany',
      error: 'Nie udało się wyszukać obrazków',
    },
    fileUpload: {
      imageGallery: {
        title: 'Galeria obrazków',
        noImages: 'Brak dodanych obrazków',
        primary: 'Główny',
        addFromUrl: 'Dodaj z URL',
        urlPlaceholder: 'Wklej adres URL obrazka (https://...)',
        hostOption: 'Hostowanie',
        hostLocally: 'Lokalnie (ściągnij i zapisz)',
        hostExternally: 'Zewnętrznie (tylko zapisz URL)',
        confirmDelete: 'Czy na pewno chcesz usunąć ten obrazek?',
        messages: {
          uploadSuccess: 'Obrazek został dodany',
          uploadSuccessMultiple: 'Dodano {count} obrazków | Dodano {count} obrazek | Dodano {count} obrazki | Dodano {count} obrazków',
          uploadFailed: 'Nie udało się dodać obrazka',
          deleteSuccess: 'Obrazek został usunięty',
          primarySuccess: 'Obrazek główny został zaktualizowany',
          primaryUnset: 'Obrazek główny został odznaczony',
          reorderSuccess: 'Kolejność obrazków została zaktualizowana',
          urlRequired: 'Adres URL obrazka jest wymagany',
          urlInvalid: 'Podaj poprawny adres URL',
          fetchingImages: 'Pobieranie obrazków...',
        },
        tooltips: {
          togglePrimary: 'Przełącz obrazek główny',
          dragToReorder: 'Przeciągnij, aby zmienić kolejność',
          deleteImage: 'Usuń obrazek',
        },
        previousImage: 'Poprzedni obrazek',
        nextImage: 'Następny obrazek',
      },
    },
    sorting: {
      unsavedChanges: 'Niezapisane zmiany sortowania',
      unsavedChangesDescription: 'Zmieniłeś kolejność {count} przedmiotów. Zapisać zmiany, aby zaktualizować kolejność w bazie danych? | Zmieniłeś kolejność {count} przedmiotu. Zapisać zmiany, aby zaktualizować kolejność w bazie danych? | Zmieniłeś kolejność {count} przedmiotów. Zapisać zmiany, aby zaktualizować kolejność w bazie danych? | Zmieniłeś kolejność {count} przedmiotów. Zapisać zmiany, aby zaktualizować kolejność w bazie danych?',
    },
    export: {
      title: 'Lista sprzętu',
      description: 'Lista mojego sprzętu w różnych kontenerach, wygenerowana przez Gear Stack',
      emptyContainer: '*Brak przedmiotów w kontenerze.*',
      allToMarkdown: 'Export do Markdown (dla AI)',
      allToCSV: 'Eksportuj wszystkie do CSV',
      allToJson: 'Eksportuj wszystkie do JSON',
      jsonSuccess: 'Wyeksportowano {count} kontener(ów) do JSON',
      noContainers: 'Brak kontenerów do eksportu',
      guidelines: 'Wytyczne',
      guidelinesDescription: 'Wytyczne formatowania dla AI przy generowaniu lub aktualizacji list sprzętu',
      guidelinesCopied: 'Wytyczne formatowania skopiowane do schowka',
      legendTitle: '## Legenda dla AI',
      legendIntro: 'To jest system zarządzania sprzętem/ekwipunkiem. Oto co oznaczają dane:',
      legendContainer: '- **Kontener**: Plecak, torba, saszetka lub inna jednostka przechowywania przedmiotów',
      legendItems: '- **Przedmioty**: Pojedyncze elementy wyposażenia przechowywane w kontenerze',
      legendWeight: '- **Waga**: Całkowita waga uwzględniająca ilość',
      legendBrand: '- **Marka**: Producent/marka przedmiotu',
      legendColor: '- **Kolor**: Kolor przedmiotu',
      legendNested: '- **Zagnieżdżone kontenery**: Kontener może zawierać inny kontener jako przedmiot. Zagnieżdżone kontenery są wyświetlane jako pozycja w liście oraz osobno z pełną zawartością poniżej.',
      legendStatusOwned: 'Przedmiot jest posiadany i dostępny',
      legendStatusMissing: 'Przedmiot jest brakujący lub niedostępny',
      legendStatusToBuy: 'Przedmiot należy zakupić',
      showUuid: 'Pokaż UUID w eksporcie',
      showWeight: 'Pokaż wagę',
      showColor: 'Pokaż kolor',
      showBrand: 'Pokaż firmę',
      showNestedContainer: 'Pokaż powiązanie z kontenerem',
      showLegend: 'Pokaż legendę',
      showPrices: 'Pokaż ceny',
      showPricesDescription: 'Uwzględnij ceny przedmiotów i kontenerów w eksporcie',
      showNotes: 'Pokaż notatki/opisy',
      toBuyTitle: 'Do zakupu',
      toBuyTotalCost: 'Całkowity koszt',
      toBuyItemsToPurchase: 'Przedmioty do zakupu',
      options: 'Opcje eksportu',
      descriptionFormat: 'Format opisów przedmiotów',
      descriptionFormatOff: 'WYŁĄCZONE',
      descriptionFormatInline: 'W nawiasie',
      descriptionFormatNewline: 'W nowej linii',
      csv: {
        title: 'Eksport do CSV',
        description: 'Skonfiguruj opcje eksportu CSV',
        columns: 'Kolumny do eksportu',
        selectAll: 'Zaznacz wszystkie',
        deselectAll: 'Odznacz wszystkie',
        separator: 'Separator',
        separatorComma: 'Przecinek (,)',
        separatorSemicolon: 'Średnik (;)',
        useBOM: 'UTF-8 z BOM (dla kompatybilności z Excel)',
        includeNested: 'Uwzględnij zagnieżdżone kontenery',
        itemsCount: 'Zostanie wyeksportowanych {count} przedmiotów | Zostanie wyeksportowany {count} przedmiot | Zostanie wyeksportowane {count} przedmioty | Zostanie wyeksportowanych {count} przedmiotów',
        success: 'CSV wyeksportowany pomyślnie',
        noColumnsSelected: 'Proszę wybrać przynajmniej jedną kolumnę',
        export: 'Eksportuj',
        categoryBasic: 'Podstawowe',
        categoryPhysical: 'Fizyczne',
        categoryFinancial: 'Finansowe',
        categoryDetails: 'Szczegóły',
        categoryAdditional: 'Dodatkowe',
        columnName: 'Nazwa',
        columnCategory: 'Kategoria',
        columnQuantity: 'Ilość',
        columnWeight: 'Waga',
        columnWeightUnit: 'Jednostka wagi',
        columnPrice: 'Cena',
        columnCurrency: 'Waluta',
        columnBrand: 'Marka',
        columnColor: 'Kolor',
        columnStatus: 'Status',
        columnPriority: 'Priorytet',
        columnUrl: 'URL',
        columnNotes: 'Notatki',
        columnContainerName: 'Nazwa kontenera',
        columnContainerType: 'Typ kontenera',
      },
    },
    allItems: {
      title: 'Wszystkie przedmioty',
      subtitle: 'Przeglądaj i zarządzaj wszystkimi przedmiotami ze wszystkich kontenerów',
      navTitle: 'Wszystkie przedmioty',
      container: 'Kontener',
      empty: 'Brak przedmiotów',
      emptyDescription: 'Utwórz kontenery i dodaj przedmioty, aby zobaczyć je tutaj.',
      filter: {
        all: 'Wszystkie',
        containers: 'Kontenery',
        items: 'Przedmioty',
      },
      filters: {
        menu: 'Więcej filtrów',
        withImage: 'Tylko z obrazkiem',
        withoutImage: 'Tylko bez obrazka',
        removeFilter: 'Usuń filtr',
      },
    },
    sidebar: {
      containerDisambiguator: '{type} · {count} przedm.',
      searchContainers: 'Szukaj kontenerów…',
      favorites: 'Ulubione',
      noContainersFound: 'Nie znaleziono kontenerów',
    },
    shopping: {
      title: 'Planowanie Zakupów',
      subtitle: 'Zaplanuj zakupy przedmiotów do kupienia i z bliskim terminem ważności',
      navTitle: 'Zakupy',
      filters: 'Filtry',
      expandFilters: 'Rozwiń filtry',
      collapseFilters: 'Zwiń filtry',
      filterByCategory: 'Filtruj po kategorii',
      filterByBudget: 'Filtruj po budżecie',
      budgetPlaceholder: 'Wprowadź kwotę budżetu',
      currency: 'PLN',
      clearBudget: 'Wyczyść',
      includeExpiringSoon: 'Uwzględnij przedmioty z bliskim terminem ważności',
      shoppingList: 'Lista zakupów',
      itemsCount: '{count} przedmiotów | {count} przedmiot | {count} przedmioty | {count} przedmiotów',
      totalQuantity: '{count} sztuk | {count} sztuka | {count} sztuki | {count} sztuk',
      clearList: 'Wyczyść listę',
      noItems: 'Brak przedmiotów',
      noItemsDescription: 'Spróbuj zmienić filtry',
      addedToCart: 'Dodano do listy zakupów',
      removedFromCart: 'Usunięto z listy zakupów',
      addAll: 'Dodaj wszystko',
      addedAllToCart: 'Dodano {count} przedmiotów do listy zakupów | Dodano {count} przedmiot do listy zakupów | Dodano {count} przedmioty do listy zakupów | Dodano {count} przedmiotów do listy zakupów',
      allItemsAlreadyInList: 'Wszystkie przedmioty są już na liście zakupów',
      exportMarkdown: 'Eksportuj Markdown',
      exportDescription: 'Skopiuj poniższą treść markdown',
      copyMarkdown: 'Skopiuj do schowka',
      markdownCopied: 'Markdown skopiowany do schowka',
      copyFailed: 'Nie udało się skopiować markdown',
      generatedAt: 'Wygenerowano',
      totalPrice: 'Razem',
      emptyList: 'Lista zakupów jest pusta',
      addItem: 'Dodaj',
      addItemDescription: 'Dodaj nowy przedmiot do listy zakupów',
      purchased: 'Kupione',
      markedAsPurchased: 'Przedmiot oznaczony jako kupiony',
      deletedFromList: 'Przedmiot usunięty z listy zakupów',
      restore: 'Przywróć',
      restoredToList: 'Przedmiot przywrócony do listy zakupów',
      reset: 'Reset',
      listReset: 'Lista zakupów zresetowana',
      summary: 'Podsumowanie',
      availableItems: 'Dostępne przedmioty',
      deletedItems: 'Usunięte',
      noContainer: 'Brak dostępnego kontenera',
      itemAdded: 'Przedmiot dodany',
      incrementQuantity: 'Zwiększ ilość',
      decrementQuantity: 'Zmniejsz ilość',
      removeFromList: 'Usuń z listy',
    },
    chart: {
      title: 'Rozkład kategorii',
      description: 'Wizualizacja kategorii przedmiotów w kontenerze',
      byWeight: 'Waga',
      byQuantity: 'Ilość',
      byPrice: 'Cena',
      byPriority: 'Priorytet',
      byWeightBreakdown: 'Inne / Noszone / Zużywalna',
      legend: 'Legenda',
      total: 'Łącznie',
      noData: 'Brak danych do wyświetlenia',
      loading: 'Ładowanie wykresu...',
    },
    weightBreakdown: {
      base: 'Inne',
      worn: 'Noszone',
      consumable: 'Zużywalna',
      baseDescription: 'Przedmioty w plecaku (nie noszone ani zużywalne)',
      wornDescription: 'Przedmioty noszone na sobie',
      consumableDescription: 'Przedmioty zużywane/zużywalne',
    },
    filters: {
      search: 'Szukaj przedmiotów...',
      searchContainers: 'Szukaj kontenerów...',
      category: 'Kategoria',
      categoryQuickFilters: 'Filtry kategorii',
      filterByCategory: 'Filtruj: {category}',
      status: 'Status',
      priority: 'Priorytet',
      all: 'Wszystkie',
      refresh: 'Odśwież kontenery',
    },
    validation: {
      nameRequired: 'Nazwa jest wymagana',
      quantityMin: 'Ilość musi być większa od 0',
      weightMin: 'Waga nie może być ujemna',
    },
    comboBox: {
      add: 'Dodaj',
    },
    import: {
      title: 'Import z Markdown',
      description: 'Wklej treść markdown, aby zaimportować kontenery i przedmioty.',
      fromMarkdown: 'Import z Markdown',
      markdownContent: 'Treść Markdown',
      placeholder: `## Nazwa kontenera
- Nazwa przedmiotu **Marka** (parametry) x5
- Inny przedmiot **Marka** ~25 m (kolor)`,
      preview: 'Podgląd',
      import: 'Importuj',
      previewTitle: 'Podgląd Importu',
      emptyContent: 'Najpierw wklej treść markdown',
      noContainersFound: 'Nie znaleziono kontenerów w markdown',
      noPreview: 'Najpierw wyświetl podgląd importu',
      previewSuccess: '{count} kontenerów | {count} kontener | {count} kontenery | {count} kontenerów',
      success: 'Pomyślnie zaimportowano {containers} kontener(ów) z {items} przedmiot(ami)',
      successWithUpdates: 'Utworzono {created} kontenerów, zaktualizowano {updated} kontenerów, utworzono {items} przedmiotów, zaktualizowano {itemsUpdated} przedmiotów',
      importedDescription: 'Zaimportowano z markdown',
      errors: 'Błędy Parsowania',
      items: 'przedmiotów',
      andMore: '+ {count} więcej... | + {count} więcej... | + {count} więcej... | + {count} więcej...',
      mode: 'Tryb Importu',
      modeUpdate: 'Aktualizuj Istniejące (po UUID)',
      modeUpdateDesc: 'Aktualizuj istniejące kontenery/przedmioty jeśli UUID pasuje, utwórz nowe jeśli nie znaleziono',
      modeCreate: 'Utwórz Nowe',
      modeCreateDesc: 'Zawsze twórz nowe kontenery/przedmioty, ignoruj UUID',
      recognizeFromName: 'Rozpoznawaj markę i kolor z nazwy',
      recognizeFromNameDesc: 'Automatycznie wykrywaj markę i kolor z nazw przedmiotów (tak jak przy zwykłym tworzeniu)',
      parsing: 'Parsowanie markdown...',
      parseProgress: 'Postęp parsowania',
      importing: 'Importowanie...',
      progress: 'Postęp',
      importingItem: 'Importowanie przedmiotu',
    },
    sampleSet: {
      generate: 'Generuj przykładowy zestaw',
      generateButton: 'Generuj przykładowy zestaw',
      success: 'Przykładowy zestaw został utworzony',
      backpack: 'Plecak',
      pouch: 'Saszetka na ogień',
      knife: 'Nóż [nazwa]',
      multiTool: 'Multi-tool [nazwa]',
      flashlight: 'Latarka [nazwa]',
      firstAidKit: 'Apteczka',
      paracord: 'Paracord',
      ferroRod: 'Krzesiwo magnezowe / Ferro Rod',
      tinder: 'Rozpałka / Char Cloth',
      lighter: 'Zapalniczka',
      variants: {
        firePouch: {
          name: 'Saszetka na ogień',
          description: 'Minimalistyczny zestaw do rozpalania ognia',
        },
        bugOutBag: {
          name: 'Bug Out Bag',
          description: 'Kompletny zestaw survivalowy na wypadek sytuacji awaryjnych',
          firePouch: 'Saszetka na ogień',
        },
        edc: {
          name: 'EDC (Every Day Carry)',
          description: 'Niezbędne przedmioty do codziennego noszenia',
        },
        budgetEdc: {
          name: 'Budżetowy zestaw EDC Survival',
          description: 'Przystępne cenowo podstawowe przedmioty survivalowe do codziennego noszenia',
        },
        mediumEdc: {
          name: 'Średni zestaw EDC / Urban Survival',
          description: 'Zestaw średniego poziomu do codziennego noszenia z naciskiem na survival miejski',
        },
      },
      items: {
        lightMyFireFiresteel: {
          name: 'Light My Fire FireSteel 2.0',
          notes: 'Krzesiwo ferrocerowe ze strykerem',
        },
        coghlansTinderQuik: {
          name: 'Coghlan\'s Tinder Quik',
          notes: 'Zapalające tabliczki',
        },
        bicLighter: {
          name: 'Zapalniczka BIC',
          notes: 'Klasyczna jednorazowa zapalniczka',
        },
        ucoStormproofMatches: {
          name: 'Zapałki wodoodporne UCO',
          notes: 'Wodoodporne zapałki w etui',
        },
        moraknivCompanion: {
          name: 'Morakniv Companion',
          notes: 'Nóż z stałym ostrzem',
        },
        leathermanWave: {
          name: 'Leatherman Wave+',
          notes: 'Multi-tool z szczypcami',
        },
        fenixPD36R: {
          name: 'Fenix PD36R',
          notes: 'Latarka z możliwością ładowania',
        },
        adventureMedicalKitsUltralight: {
          name: 'Apteczka Adventure Medical Kits Ultralight',
          notes: 'Apteczka pierwszej pomocy',
        },
        paracord550: {
          name: 'Paracord 550',
          notes: 'Paracord 50 stóp',
        },
        lifestrawPersonal: {
          name: 'Filtr do wody LifeStraw Personal',
          notes: 'Przenośny filtr do wody',
        },
        solEmergencyBivvy: {
          name: 'SOL Emergency Bivvy',
          notes: 'Awaryjne schronienie',
        },
        victorinoxClassicSD: {
          name: 'Victorinox Swiss Army Knife Classic SD',
          notes: 'Kompaktowy multi-tool',
        },
        olightI3TEOS: {
          name: 'Olight I3T EOS',
          notes: 'Latarka na brelok',
        },
        zippoLighter: {
          name: 'Zapalniczka Zippo',
          notes: 'Zapalniczka wiatroodporna',
        },
        fieldNotesNotebook: {
          name: 'Notatnik Field Notes',
          notes: 'Kieszonkowy notatnik',
        },
        fisherSpacePen: {
          name: 'Długopis Fisher Space Pen',
          notes: 'Długopis ciśnieniowy',
        },
        ankerPowerCore10000: {
          name: 'Power bank Anker PowerCore 10000',
          notes: 'Przenośny power bank',
        },
        riteInTheRainNotepad: {
          name: 'Notes wodoodporny Rite in the Rain 3x5',
          notes: 'Wodoodporny notes kieszonkowy',
        },
        sharpieMarker: {
          name: 'Marker permanentny Sharpie',
          notes: 'Marker permanentny z cienką końcówką',
        },
        ductTape: {
          name: 'Kompaktowa taśma duct tape (10 m)',
          notes: 'Taśma do napraw i improwizacji',
        },
        metalSpork: {
          name: 'Metalowy spork',
          notes: 'Składana łyżko-widelec (tytan / stal)',
        },
        cnocVectoBottle: {
          name: 'Butelka składana CNOC Vecto 1L',
          notes: 'Składana butelka na wodę',
        },
        fenixE01: {
          name: 'Fenix E01 V2.0',
          notes: 'Ultra-lekka latarka AAA jako backup',
        },
        victorinoxHuntsman: {
          name: 'Victorinox Huntsman',
          notes: 'Scyzoryk z piłką i nożyczkami',
        },
        ferroRod8mm: {
          name: 'Krzesiwo ferrocerowe 8 mm',
          notes: 'Kompaktowe krzesiwo do rozpalania ognia',
        },
        gsiStainlessCup: {
          name: 'Kubek stalowy GSI Outdoors 700 ml',
          notes: 'Metalowy kubek do gotowania wody lub posiłków',
        },
        milTecEmergencyBlanket: {
          name: 'Koc termiczny Mil-Tec',
          notes: 'Awaryjna folia ratunkowa',
        },
        basicMiniFirstAidKit: {
          name: 'Apteczka Adventure Medical Kits Ultralight/.5',
          notes: 'Kompaktowa apteczka na 1–2 osoby',
        },
      },
    },
    migration: {
      title: 'Migrować dane lokalne?',
      description: 'Znaleźliśmy dane przechowywane lokalnie. Czy chcesz je przenieść do swojego konta?',
      benefits: {
        title: 'Korzyści z migracji:',
        sync: 'Synchronizacja na wszystkich urządzeniach',
        backup: 'Automatyczna kopia zapasowa w chmurze',
        access: 'Dostęp z dowolnego miejsca',
      },
      note: 'Twoje dane lokalne pozostaną dostępne nawet po migracji. Możesz nadal korzystać z aplikacji offline.',
      skip: 'Pomiń',
      migrate: 'Migruj',
      migrating: 'Migrowanie...',
      success: 'Dane zostały pomyślnie zmigrowane!',
      error: 'Nie udało się zmigrować danych. Spróbuj ponownie.',
    },
    publicContainers: {
      title: 'Kontenery publiczne',
      navTitle: 'Kontenery publiczne',
      description: 'Przeglądaj kontenery udostępnione przez innych użytkowników',
      by: 'autor',
      author: 'Autor',
      empty: 'Brak publicznych kontenerów',
      emptyDescription: 'Nie ma jeszcze dostępnych publicznych kontenerów. Utwórz kontener i oznacz go jako publiczny, aby udostępnić go innym.',
    },
    sharedContainers: {
      title: 'Udostępniony Kontener',
      notFound: 'Udostępniony kontener nie został znaleziony lub token wygasł',
      invalidToken: 'Nieprawidłowy lub wygasły token udostępniania',
    },
    shareTokens: {
      title: 'Zarządzaj Tokenami Udostępniania',
      create: 'Utwórz Token',
      createFirst: 'Utwórz Pierwszy Token',
      createDescription: 'Utwórz nowy token udostępniania, aby umożliwić innym przeglądanie tego kontenera za pomocą linku.',
      shareUrl: 'URL Udostępniania',
      created: 'Utworzono',
      expires: 'Wygasa',
      noExpiry: 'Nigdy',
      expiryDate: 'Data Wygasania (Opcjonalna)',
      expiryPlaceholder: 'Pozostaw puste, aby nie ustawiać wygaśnięcia',
      expiryHint: 'Pozostaw puste, aby utworzyć token, który nigdy nie wygasa.',
      empty: 'Nie utworzono jeszcze żadnych tokenów udostępniania.',
      copied: 'URL udostępniania skopiowany do schowka',
      createdSuccess: 'Token udostępniania został utworzony pomyślnie',
      revoked: 'Token udostępniania został odwołany pomyślnie',
      confirmRevoke: 'Czy na pewno chcesz odwołać ten token udostępniania?',
      errorLoading: 'Nie udało się załadować tokenów udostępniania',
      errorCreating: 'Nie udało się utworzyć tokenu udostępniania',
      errorRevoking: 'Nie udało się odwołać tokenu udostępniania',
      errorCopying: 'Nie udało się skopiować do schowka',
    },
    errors: {
      ratingFailed: 'Nie udało się ocenić kontenera',
      deleteRatingFailed: 'Nie udało się usunąć oceny',
    },
    report: {
      title: 'Zgłoś nieodpowiednie treści',
      description: 'Pomóż nam utrzymać bezpieczeństwo społeczności, zgłaszając kontenery naruszające nasze wytyczne.',
      reason: 'Powód',
      reasonPlaceholder: 'Wybierz powód',
      reasonRequired: 'Proszę wybrać powód',
      reasons: {
        spam_fraud: 'Spam / Oszustwa',
        violence: 'Przemoc',
        sexual_content: 'Treści seksualne',
        profanity: 'Wulgaryzmy',
        other: 'Inne',
      },
      additionalInfo: 'Dodatkowe informacje',
      additionalInfoPlaceholder: 'Podaj dodatkowe szczegóły (opcjonalnie)',
      additionalInfoHint: 'Opcjonalnie: Dodaj dodatkowy kontekst, który może pomóc nam w weryfikacji tego zgłoszenia.',
      submit: 'Zgłoś',
      cancel: 'Anuluj',
      success: 'Zgłoszenie zostało wysłane',
      successDescription: 'Dziękujemy za zgłoszenie. Przejrzymy je wkrótce.',
      error: 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie.',
      alreadyReported: 'Ten kontener został już przez Ciebie zgłoszony',
      alreadyReportedInfo: 'Ten kontener został już przez Ciebie zgłoszony',
      withdraw: 'Cofnij zgłoszenie',
      withdrawConfirm: 'Czy na pewno chcesz cofnąć swoje zgłoszenie?',
      withdrawSuccess: 'Zgłoszenie zostało cofnięte',
      withdrawError: 'Nie udało się cofnąć zgłoszenia',
      clickToWithdraw: 'Kliknij aby cofnąć zgłoszenie',
      report: 'Zgłoś',
    },
    pages: {
      allItems: 'Wszystkie przedmioty',
      shoppingPlanning: 'Planowanie zakupów',
      containerDetail: 'Szczegóły kontenera',
      itemDetail: 'Szczegóły przedmiotu',
      publicContainers: 'Kontenery publiczne',
      publicContainerDetail: 'Publiczny kontener',
      publicItemDetail: 'Publiczny przedmiot',
      sharedContainerDetail: 'Udostępniony kontener',
    },
    settings: {
      page: {
        title: 'Ustawienia sprzętu',
        subtitle: 'Zarządzaj preferencjami i ustawieniami dotyczącymi sprzętu',
      },
      ai: {
        title: 'Ustawienia AI',
        description: 'Skonfiguruj model AI, token API i limity użycia',
        defaultModel: {
          label: 'Domyślny Model',
          subtitle: 'Wybierz domyślny model AI do użycia w czacie i sugestiach',
          placeholder: 'Wybierz model',
        },
        apiToken: {
          label: 'Token API',
          subtitle: 'Użyj własnego tokena OpenRouter API dla nieograniczonego użycia (opcjonalnie)',
          placeholder: 'Wprowadź swój token OpenRouter API',
          save: 'Zapisz Token',
          remove: 'Usuń Token',
          configured: 'Token skonfigurowany',
          encrypted: 'Token jest szyfrowany i przechowywany bezpiecznie',
          confirmRemove: {
            title: 'Usuń Token API',
            description: 'Czy na pewno chcesz usunąć swój token API? Będziesz musiał skonfigurować go ponownie, aby korzystać z funkcji AI z własnym tokenem.',
          },
        },
        usage: {
          label: 'Użycie i Limity',
          subtitle: 'Aktualne statystyki użycia i limity dla tego miesiąca',
          tokens: 'Tokeny',
          cost: 'Koszt',
          unlimited: 'Bez limitu',
          noLimit: 'Brak limitu',
          unavailable: 'Niedostępne',
          ownTokenNote: 'Używasz własnego tokena API. Użycie jest nieograniczone.',
          systemTokenNote: 'Używasz tokena systemowego. Obowiązują limity.',
        },
        modelUpdated: 'Model został zaktualizowany',
        tokenSaved: 'Token API został zapisany',
        tokenRemoved: 'Token API został usunięty',
        tokenRequired: 'Token API jest wymagany',
        tokenSaveError: 'Nie udało się zapisać tokena API',
        tokenRemoveError: 'Nie udało się usunąć tokena API',
      },
      accountLimits: {
        title: 'Limity Konta',
        description: 'Twoje limity konta i aktualne wykorzystanie',
        plan: 'Plan',
        tier: {
          free: 'Darmowy',
          pro: 'Pro',
          proPlus: 'Pro Plus',
        },
        items: 'Przedmioty',
        containers: 'Kontenery',
        used: 'użyto',
        upgradePrompt: 'Zbliżasz się do limitów swojego konta. Rozważ upgrade do Pro, aby uzyskać więcej miejsca.',
      },
    },
    catalogue: {
    title: 'Globalny Katalog Przedmiotów',
    subtitle: 'Przeglądaj i dodawaj przedmioty z katalogu przedmiotów',
    navTitle: 'Katalog przedmiotów',
    browser: 'Przeglądarka Katalogu',
    search: 'Szukaj w katalogu...',
    searchPlaceholder: 'Szukaj po nazwie, marce lub modelu...',
    filters: 'Filtry',
    category: 'Kategoria',
    brand: 'Marka',
    priceTier: 'Półka cenowa',
    quality: 'Jakość',
    clearFilters: 'Wyczyść filtry',
    noResults: 'Nie znaleziono przedmiotów w katalogu',
    noResultsDescription: 'Spróbuj zmienić wyszukiwanie lub filtry',
    itemDetail: 'Szczegóły przedmiotu z katalogu',
    addToContainer: 'Dodaj do kontenera',
    selectContainer: 'Wybierz kontener',
    selectContainerPlaceholder: 'Wybierz kontener...',
    addOptions: 'Opcje dodawania',
    quantity: 'Ilość',
    status: 'Status',
    priority: 'Priorytet',
      copyImage: 'Dodaj z obrazkiem',
      shouldRedirectToContainer: 'Przekieruj do kontenera po dodaniu',
      addedToContainer: 'Przedmiot został dodany do kontenera',
    matchWithCatalogue: 'Powiąż z katalogiem',
    matchedWithCatalogue: 'Przedmiot został powiązany z katalogiem',
    searchCatalogue: 'Wyszukaj w katalogu',
    noMatchesFound: 'Nie znaleziono pasujących wyników',
    selectedCatalogueItem: 'Wybrany przedmiot z katalogu',
    match: 'Powiąż',
    description: 'Opis',
    weightWithUnit: 'Waga (z jednostką)',
    priceWithCurrency: 'Cena (z walutą)',
    updateFromCatalogue: 'Aktualizuj z katalogu',
    updatedFromCatalogue: 'Przedmiot został zaktualizowany z katalogu',
    selectFieldsToUpdate: 'Wybierz które pola zaktualizować z katalogu',
    update: 'Aktualizuj',
    fetchImagesFromCatalogue: 'Pobierz obrazki z katalogu',
    fetchedImagesFromCatalogue: 'Obrazki zostały pobrane z katalogu',
    unlinkFromCatalogue: 'Odłącz od katalogu',
    unlinkConfirm: 'Czy na pewno chcesz odłączyć ten przedmiot od katalogu?',
    unlinkedSuccess: 'Przedmiot został odłączony od katalogu',
    linkedToCatalogue: 'Powiązany z katalogiem',
    viewInCatalogue: 'Zobacz w katalogu',
    fromCatalogue: 'Z katalogu',
    priceTiers: {
      low: 'Budżetowy',
      medium: 'Średnia półka',
      high: 'Premium',
    },
    create: {
      title: 'Utwórz przedmiot w katalogu',
      description: 'Dodaj nowy przedmiot do katalogu przedmiotów',
    },
    edit: {
      title: 'Edytuj przedmiot z katalogu',
      description: 'Zaktualizuj szczegóły przedmiotu w katalogu',
    },
    version: 'Wersja',
    createdBy: 'Utworzono przez',
    user: 'Użytkownik',
    isActive: 'Aktywny',
    makeInactive: 'Dezaktywuj',
    makeActive: 'Aktywuj',
    delete: 'Usuń przedmiot z katalogu',
    deleteConfirm: 'Czy na pewno chcesz usunąć ten przedmiot z katalogu?',
    empty: 'Brak przedmiotów w katalogu',
    emptyDescription: 'Katalog przedmiotów jest pusty. Dodaj przedmioty, aby pomóc innym znaleźć sprzęt.',
      metadata: 'Metadane',
      metadataCreated: 'Utworzono',
      metadataUpdated: 'Zaktualizowano',
      model: 'Model',
      admin: 'Admin',
      shops: 'Sklepy',
      shopsTitle: 'Gdzie kupić',
      shopLink: 'Link do sklepu',
      openShop: 'Otwórz sklep',
      priceDate: 'Cena orientacyjna na dzień {date}',
    },
    promotion: {
      title: 'Promuj do Katalogu',
      promotions: 'Promocje',
      promoteButton: 'Promuj',
      alreadyPromoted: 'Już promowałeś ten przedmiot',
      addedToCatalogue: 'Przedmiot został dodany do katalogu',
      inCatalogue: 'W Katalogu',
      remaining: '{count} pozostało | {count} pozostało | {count} pozostało | {count} pozostało',
      thresholdReached: 'Próg osiągnięty! Przedmiot zostanie dodany do katalogu.',
      requirements: 'Tylko zarejestrowani użytkownicy z kontem starszym niż 1 miesiąc mogą promować przedmioty.',
      success: 'Przedmiot został wypromowany',
      addToCatalogueAdmin: 'Dodaj do Katalogu',
    },
    visualization: {
      title: 'Wizualizacja',
      navTitle: 'Wizualizacja',
      description: 'Mapa wizualna sprzętu według stref przechowywania',
      zones: {
        body: 'Na sobie',
        carry: 'Noszone',
        vehicle: 'Pojazd',
        home: 'Dom / Magazyn',
        other: 'Inne',
      },
      zoneEmpty: 'Brak kontenerów w tej strefie',
      addZone: 'Dodaj obszar',
      zoneDialog: {
        addTitle: 'Dodaj obszar',
        editTitle: 'Edytuj obszar',
        nameLabel: 'Nazwa',
        namePlaceholder: 'np. Łódź, Obozowisko',
        iconLabel: 'Ikona',
      },
      confirmDeleteZone: 'Usunąć ten obszar? Kontenery w nim umieszczone wrócą do domyślnej strefy.',
    },
  },
}

